class ProductTabs extends HTMLElement {
  constructor() {
    super()

    this.handleTabClick = this.handleTabClick.bind(this)
    this.tabButtons = this.querySelectorAll('[data-tab-button]')
    this.tabPanels = this.querySelectorAll('[data-tab-panel]')
  }

  connectedCallback() {
    this.setInitialPanelHeight()
    this.setInitialButtonUnderline()
    this.tabButtons.forEach((button) =>
      button.addEventListener('click', this.handleTabClick)
    )
  }

  handleTabClick(evt) {
    const button = evt.currentTarget
    const panelId = button.dataset.tabId

    this.showTabContent(panelId)
    this.updateButtonUnderline(button)
    this.updateButtonStates(button)
  }

  showTabContent(panelId) {
    const selectedPanel = this.querySelector(`[data-panel-id="${panelId}"]`)
    if (!selectedPanel) return

    this.tabPanels.forEach((panel) => {
      panel.classList.toggle('active', panel === selectedPanel)
      panel.ariaHidden = panel !== selectedPanel
    })

    this.calculatePanelHeight(selectedPanel)
  }

  updateButtonStates(activeButton) {
    this.tabButtons.forEach((button) => {
      button.classList.toggle('active', button === activeButton)
      button.ariaExpanded = button === activeButton
    })
  }

  updateButtonUnderline(button) {
    this.style.setProperty('--Button_Width', `${button.offsetWidth}px`)
    this.style.setProperty('--Underline_LeftPosition', `${button.offsetLeft}px`)
  }

  setInitialPanelHeight() {
    const activePanel = this.querySelector('[data-tab-panel].active')
    if (activePanel) {
      this.calculatePanelHeight(activePanel)
    }
  }

  setInitialButtonUnderline() {
    const activeButton = this.querySelector('[data-tab-button].active')
    console.log(activeButton);

    if (activeButton) {
      this.updateButtonUnderline(activeButton)
    }
  }

  calculatePanelHeight(panel) {
    const panelHeight = panel.scrollHeight
    this.style.setProperty('--Panel_Height', `${panelHeight}px`)
  }
}

if (!customElements.get('product-tabs')) {
  customElements.define('product-tabs', ProductTabs)
}